.as{flex-wrap:wrap;}